module.exports = __webpack_public_path__ + "static/img/b6_footer.3503851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b6_footer.png
// module id = 0ViH
// module chunks = 1